module.exports = __webpack_public_path__ + "/login_ui/img/ge-d4167ddb4e786908561b0b585038f7d7.svg";